import {createReducer} from "redux-act";
import {fetchSquadsSuccess} from "modules/actions";
import {Groups} from "modules/types";

export interface ISquad {
	id: number;
	name: string;
	abbr: string;
	seed: number;
	squadLink: string | null;
	isActive: boolean;
	group: Groups;
	groupPosition: number | null;
	color: string | null;
}

export type ISquadsReducer = ISquad[];

const onFetchSquadsSuccess = (state: ISquadsReducer, payload: ISquad[]) => payload;

export const squads = createReducer<ISquadsReducer>({}, []).on(
	fetchSquadsSuccess,
	onFetchSquadsSuccess
);
